import React from 'react';
import { Outlet, Navigate } from 'react-router-dom';

const Privateroutes = () => {
    const isAuthenticated = !!sessionStorage.getItem('quotetoken');

    if (!isAuthenticated) {
        return <Navigate to="/sign-in" />;
    } else {
        return <Outlet />;
    }
}

export default Privateroutes;